import { useOutletContext } from 'react-router-dom';

interface UserScanHistory {
  user: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    imageUrl: string | null;
  };
  scans: Array<{
    id: string;
    scannedAt: string;
    expiresAt: string | null;
    revokedAt?: string | null;
    ipAddress?: string | null;
    userAgent?: string | null;
    accessCode: {
      id: string;
      name: string;
      code: string;
    } | null;
    isMostRecent?: boolean;
    canModify?: boolean;
  }>;
}

interface HotelUserContext {
  userData: UserScanHistory | undefined;
  isLoading: boolean;
  hotelId: string | undefined;
}

export type { UserScanHistory };

export function useHotelUserContext() {
  return useOutletContext<HotelUserContext>();
}
